import { SvgIcon, SvgIconProps } from '@mui/material'
import React from 'react'

export const ArrowForward:React.FC<SvgIconProps> = (props) => (
  <SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path d="M4 12H20M20 12L14 6M20 12L14 18" stroke="currentColor" fill="transparent" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  </SvgIcon>
)
